import axios from "axios";
import queryStr from "qs";
import * as Api from "../../Api/Api";
import * as actionTypes from "./actionTypes";

import { toast } from "react-toastify";

const LoginStart = () => {
  return {
    type: actionTypes.LOGIN_START,
  };
};
const LoginSuccess = (data) => {
  return {
    type: actionTypes.LOGIN_SUCCESS,
    data,
  };
};
const LoginFail = (err) => {
  return {
    type: actionTypes.LOGIN_FAIL,
    err,
  };
};

export const LoginMainFunc = (deviceId, data, navigate) => {
  return async (dispatch) => {
    dispatch(LoginStart());

    try {
      //green token
      const res = Api.greenTokenApiCallPostFunction(
        "POST",
        `${process.env.REACT_APP_SITE_PRODUCTION_URL + "greenAuthtoken"}`,
        "application/x-www-form-urlencoded",
        {
          client_secret: window.btoa(process.env.REACT_APP_CLIENT_SECRET),
          client_id: window.btoa(process.env.REACT_APP_CLIENT_ID),
          UserName: data.username,
          Password: data.pass,
          longitude: data.longitude,
          latitude: data.latitude,
          grant_type: "password",
          deviceId: deviceId,
          // OTP: OTP,
        }
      );

      const finaldata = await res;
      if (finaldata !== "Unauthorized") {
        if (finaldata.data) {
          //timer
          var dateOne = new Date(),
            dateTwo = new Date(dateOne);
          let mintToAdd = parseInt(Number(finaldata.data.expires_in) / 60) - 5;
          dateTwo.setMinutes(dateOne.getMinutes() + mintToAdd);

          sessionStorage.setItem("timer", dateTwo);

          //login

          const loginRes = await axios(
            `${process.env.REACT_APP_SITE_PRODUCTION_URL + "api/user/login"}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "access-control-allow-origin": "*",
                authorization: "Bearer " + finaldata.data.access_token,
              },
              data: queryStr.stringify({
                UserName: data.username,
                Password: data.pass,
                longitude: data.longitude,
                latitude: data.latitude,
                source: "Web",
                //OTP: OTP,
              }),
            }
          );

          let userData = loginRes;

          if (userData.data.errorCode === "200") {
            if (userData.data.data.ActiveStatus === "Yes") {
              if (userData.data.data.Status === "Active") {
                if (userData.data.data.Role === "R") {
                  sessionStorage.setItem(
                    "profilePic",
                    userData.data.data.ProfilePic
                  );
                  sessionStorage.setItem("name", userData.data.data.Name);
                  sessionStorage.setItem(
                    "role",
                    JSON.stringify(userData.data.data.Role)
                  );
                  sessionStorage.setItem("userId", userData.data.data.UserId);
                  sessionStorage.setItem(
                    "username",
                    userData.data.data.Username
                  );
                  sessionStorage.setItem("emailId", userData.data.data.emailId);
                  sessionStorage.setItem(
                    "retMobile",
                    userData.data.data.MobileNo
                  );
                  sessionStorage.setItem(
                    "access_token",
                    finaldata.data.access_token
                  );
                  sessionStorage.setItem(
                    "expires_in",
                    finaldata.data.expires_in
                  );
                  sessionStorage.setItem(
                    "refresh_token",
                    finaldata.data.refresh_token
                  );

                  navigate("/retailer/Dashboard");
                  dispatch(LoginSuccess(userData.data.data));
                } else if (userData.data.data.Role === "D") {
                  sessionStorage.setItem(
                    "profilePic",
                    userData.data.data.ProfilePic
                  );
                  sessionStorage.setItem("name", userData.data.data.Name);
                  sessionStorage.setItem("role", userData.data.data.Role);
                  sessionStorage.setItem("userId", userData.data.data.UserId);
                  sessionStorage.setItem(
                    "username",
                    userData.data.data.Username
                  );
                  sessionStorage.setItem(
                    "retMobile",
                    userData.data.data.MobileNo
                  );
                  sessionStorage.setItem(
                    "access_token",
                    finaldata.data.access_token
                  );
                  sessionStorage.setItem(
                    "expires_in",
                    finaldata.data.expires_in
                  );
                  sessionStorage.setItem(
                    "refresh_token",
                    finaldata.data.refresh_token
                  );

                  navigate("/distributor/Dashboard");
                  dispatch(LoginSuccess(userData.data.data));
                } else if (userData.data.data.Role === "SD") {
                  sessionStorage.setItem(
                    "profilePic",
                    userData.data.data.ProfilePic
                  );
                  sessionStorage.setItem("name", userData.data.data.Name);
                  sessionStorage.setItem(
                    "role",
                    JSON.stringify(userData.data.data.Role)
                  );
                  sessionStorage.setItem("userId", userData.data.data.UserId);
                  sessionStorage.setItem(
                    "username",
                    userData.data.data.Username
                  );
                  sessionStorage.setItem(
                    "retMobile",
                    userData.data.data.MobileNo
                  );
                  sessionStorage.setItem(
                    "access_token",
                    finaldata.data.access_token
                  );
                  sessionStorage.setItem(
                    "expires_in",
                    finaldata.data.expires_in
                  );
                  sessionStorage.setItem(
                    "refresh_token",
                    finaldata.data.refresh_token
                  );

                  navigate(
                    "/SuperDistributorDashboard/SuperDistributorDashboard"
                  );
                  dispatch(LoginSuccess(userData.data.data));
                }
              } else {
                toast.error("Account is Blocked. Please contact admin!");
                dispatch(
                  LoginFail({
                    msg: "Account is Blocked. Please contact admin!",
                  })
                );
              }
            } else {
              toast.error("KYC is pending. Please contact support for help!");
              dispatch(
                LoginFail({
                  msg: "KYC is pending. Please contact support for help!",
                })
              );
            }
          }
        } else {
          toast.error("Invalid Login Credentials,please check login Details!");
          dispatch(LoginFail({ msg: "Login Failed,invalid credentials!" }));
        }
      } else {
        toast.error("Invalid Login Credentials,please check login Details!");
        dispatch(LoginFail({ msg: "Login Failed,invalid credentials!" }));
      }
    } catch (err) {
      dispatch(LoginFail(err.message));
      toast.error("Some error occurred in login process");
    }
  };
};

// get active services*********************************************************************************************************************

const getActiveServicesStart = () => {
  return {
    type: actionTypes.GET_ACTIVE_SERVICES_START,
  };
};
const getActiveServicesSuccess = (data) => {
  return {
    type: actionTypes.GET_ACTIVE_SERVICES_SUCCESS,
    data,
  };
};
const getActiveServicesFail = (err) => {
  return {
    type: actionTypes.GET_ACTIVE_SERVICES_FAIL,
    err,
  };
};

export const getActiveServices = () => {
  return async (dispatch) => {
    dispatch(getActiveServicesStart());

    try {
      const res = Api.apiCallPostFunction(
        "GET",
        `${
          process.env.REACT_APP_SITE_PRODUCTION_URL +
          "/api/user/GetActiveService"
        }`
      );

      const finaldata = await res;

      if (finaldata.data.errorCode === "200") {
        dispatch(getActiveServicesSuccess(finaldata.data));
      }
    } catch (e) {
      dispatch(getActiveServicesFail(e));
    }
  };
};

// get active services*********************************************************************************************************************

const checkBalanceStart = () => {
  return {
    type: actionTypes.GET_CHECK_BALANCE_START,
  };
};
const checkBalanceSuccess = (data) => {
  return {
    type: actionTypes.GET_CHECK_BALANCE_SUCCESS,
    data,
  };
};
const checkBalanceFail = (err) => {
  return {
    type: actionTypes.GET_CHECK_BALANCE_FAIL,
    err,
  };
};

export const checkBalance = (userId) => {
  return async (dispatch) => {
    dispatch(checkBalanceStart());

    try {
      const res = Api.apiCallPostFunction(
        "GET",
        `${
          process.env.REACT_APP_SITE_PRODUCTION_URL +
          "/api/user/checkBalance" +
          "/" +
          userId
        }`
      );

      const finaldata = await res;

      if (finaldata.data.errorCode === "200") {
        dispatch(checkBalanceSuccess(finaldata.data));
      }
    } catch (e) {
      dispatch(checkBalanceFail(e));
    }
  };
};

// wallet fund request*********************************************************************************************************************

const walletFundReqStart = () => {
  return {
    type: actionTypes.WALLET_FUND_REQ_START,
  };
};
const walletFundReqSuccess = (data) => {
  return {
    type: actionTypes.WALLET_FUND_REQ_SUCCESS,
    data,
  };
};
const walletFundReqFail = (err) => {
  return {
    type: actionTypes.WALLET_FUND_REQ_FAIL,
    err,
  };
};

export const walletFundReq = (data) => {
  return async (dispatch) => {
    dispatch(walletFundReqStart());

    try {
      const res = Api.apiCallPostFunction(
        "POST",
        `${
          process.env.REACT_APP_SITE_PRODUCTION_URL + "/api/user/walletFundReq"
        }`,
        "application/x-www-form-urlencoded",
        data
      );

      const finaldata = await res;

      if (finaldata.data.errorCode === "200") {
        dispatch(walletFundReqSuccess(finaldata.data));
      } else if (finaldata.data.errorCode === "404") {
        dispatch(
          walletFundReqFail({
            msg: finaldata.data.msg,
            errorData: finaldata.data,
          })
        );
      } else {
        dispatch(
          walletFundReqFail({
            msg: "Something went wrong!",
            errorData: finaldata.data,
          })
        );
      }
    } catch (e) {
      dispatch(walletFundReqFail(e));
    }
  };
};

//close Remitter Popup

const closeRemitterPopupStart = () => {
  return {
    type: actionTypes.CLOSE_REMIITER_POPUP_START,
  };
};

export const closeRemitterPopup = () => {
  return async (dispatch) => {
    dispatch(closeRemitterPopupStart());
  };
};

//session timeout func

const sessionTypeStart = (data) => {
  return {
    type: actionTypes.SESSION_TYPE_START,
    data,
  };
};

export const sessionType = (data) => {
  return async (dispatch) => {
    dispatch(sessionTypeStart(data.what));
  };
};

//user decrypted

const userDecryptedStart = (data) => {
  return {
    type: actionTypes.USER_DATA_START,
    data,
  };
};

export const userDecrypted = (data) => {
  return async (dispatch) => {
    dispatch(userDecryptedStart(data));
  };
};

//
export const RefundWalletCahoutData = (data) => {
  return {
    type: actionTypes.REFUND_WALLET_CASHOUT_DATA,
    data,
  };
};
